import * as z from 'zod/mini';

export const PackageSessionSaveRequestSchema = z.object({
  order_session_id: z.string(),
  office_id: z.number(),
  department_id: z.number(),
  locale: z.string(),
  email: z.string(),
  name: z.string(),
  url: z.httpUrl(),
});

export const PackageSessionSaveResponseSchema = z.object({
  message: z.string(),
});
